import React from 'react'

interface DropZoneProps {
	isExpanded?: boolean
}

const DropZone: React.FC<DropZoneProps> = ({ isExpanded = false }) => {
	return (
		<div
			style={{
				height: isExpanded ? '60px' : '0px',
				margin: isExpanded ? '6px 0' : '0px',
				borderRadius: '6px',
				transition: 'all 0.2s ease',
				backgroundColor: isExpanded ? '#e3f2fd' : isExpanded ? '#f8f9fa' : 'transparent',
				border: isExpanded ? '2px dashed #2196f3' : isExpanded ? '2px dashed transparent' : 'none',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				fontSize: '12px',
				color: isExpanded ? '#2196f3' : '#6c757d',
				fontWeight: '500',
				position: 'relative',
				minWidth: '100%',
				overflow: 'hidden',
			}}
		>
			{isExpanded ? 'Drop Here' : ''}
		</div>
	)
}

export default DropZone
